module.exports = __webpack_public_path__ + "img/20190802132016QQ截图20190802015554.1f668da5.png";